import React from 'react';

export const Icon = React.lazy(() => import('./Icon'));
